import React, { useState, useRef, useEffect } from "react";
import "../Menu/addMore/orderModal.css";
import "./modalComponent.css";
import copy from "../../../Assets/copy.svg";
import convertToIST from "../../../services/istTime";
import api from "../../../services/api";
import { useToast } from "../../../mesageToast/ToastContainer";
import { useDispatch } from "react-redux";
import { orderReject } from "../../../redux/Slice/OrderSlice";
import cross from "../../../Assets/cross.svg";

function RejectModal({ isOpen, onClose, refresh, order }) {
  const dispatch = useDispatch();
  const currency = "₹";
  const addToast = useToast();
  const modalRef = useRef(null);
  const [selectedReason, setSelectedReason] = useState("");
  const [customeReasons, setCustomeReasons] = useState("");
  const [textAreaShow, setTextAreaShow] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false); // Add loading state

  // Early return if order is not available
  if (!order) {
    return null;
  }


  const handleReasonChange = (event) => {
    setSelectedReason(event.target.value); // Set selected reason
    if (event.target.value === "Other") {
      setTextAreaShow(true);
    } else {
      setTextAreaShow(false);
      setCustomeReasons("");
    }
  };
  const handleChangeTextReason = (event) => {
    const input = event.target.value;
    if (event.target.value.length > 50) {
      return setError("Maximum 50 characters allowed");
    }
    if (/^[A-Za-z0-9\s@]*$/.test(input)) {
      if (/\s{2,}/.test(input)) {
        // Prevent consecutive spaces

        setError("Consecutive spaces are not allowed");
      } else {
        setCustomeReasons(input);
        setError("");
      }
    } else {
      setError("Special characters are not allowed");
    }
  };
  const handleCopy = (orderId) => {
    navigator.clipboard.writeText(orderId.toString());
    alert(`Order ID #${orderId} copied to clipboard!`);
  };

  const handleOnClose = () => {
    setSelectedReason("");
    setCustomeReasons("");
    setTextAreaShow(false);
    onClose();
  };

  const handleReject = () => {
    if (!selectedReason) {
      addToast("Error", "Please select a reason to reject the order.", "error");
      return;
    }
    if (selectedReason === "Other" && !customeReasons) {
      setError("Please enter a reason to reject the order.");
      return;
    } else if (selectedReason === "Other" && customeReasons.length < 5) {
      setError("Please enter a reason with atleast 5 characters.");
      return;
    }
    if (selectedReason === "Other") {
      setSelectedReason(customeReasons);
    }
    let reasonsToSelect =
      selectedReason === "Other" ? customeReasons : selectedReason;
    setIsLoading(true);
    api
      .delete(`/restaurant-management/orders/Rejected/${order.id}`, {
        headers: { reason: reasonsToSelect },
      })
      .then(() => {
        addToast("Order Rejected", "Order has been rejected.", "success");
        //refresh();
        dispatch(orderReject(order.id));
        if (typeof refresh === 'function') refresh();
      })
      .catch((error) => {
        addToast("Error", "Failed to reject order.", "error");
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false); // Set loading state to false after API call completes
        handleOnClose();
      });
  };
  if (!isOpen) return null;
  return (
    <div className="modal-overlay-addDishes">
      <div className="modal-content-addDishes" ref={modalRef}>
        <button className="close" onClick={handleOnClose}>
          <img src={cross} alt="cross" />
        </button>
        <div className="modal-confirm-header">
          <h6>REJECT ORDER?</h6>
        </div>
        <div className="content-details-dishes">
          <div className="orderIdDetails" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div className="orderId">
              <p>Order ID #{order.id}</p>
            </div>
            <div className="copyButton" onClick={() => handleCopy(order.id)}>
              <img src={copy} alt="copy" />
            </div>
          </div>
          <div className="customeDetails-orderType">
            <div className="CustomerDetails">
              <div className="OrderName">
                <p>{order.user.name}</p>
              </div>
              <div className="ordertimesdetails" style={{display: "flex", alignItems: "center", gap: "5px", fontSize: "14px", color: "#555" }}>
                <div className="time">
                  {convertToIST(order.createdTime).time}
                </div>
                <div className="seperation">|</div>
                <div className="orderdayDate">
                  {convertToIST(order.createdTime).date}
                </div>
                {order.orderType === "Dine-in" && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <div className="seperation">|</div>
                    <div className="orderdayDate">
                      {order.user.person} People
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="orderType">
              <p>{order.orderType.replace("Dine-in", "Dine In")}</p>
            </div>
          </div>
          <div className="itemDetails">
            {order.user.items.map((item, index) => (
              <div className="item-unavaliable" key={index}>
                <div className="Single-Items">
                  <p>{item.name}</p>
                  <small>
                    {currency}
                    {item.price} | Qty: {item.quantity}
                  </small>
                </div>
                <div className="checkbox-markunavaliable">
                  <input type="checkbox" />
                  <label htmlFor="unavailable">Mark Unavailable</label>
                </div>
              </div>
            ))}
          </div>
          <div className="hline"></div>
          <div className="Reasons">
            <h4>Choose reason to Cancel</h4>
            <div>
              <input
                type="radio"
                id="reason1"
                name="cancelReason"
                value="Few items from the order are not available"
                checked={
                  selectedReason ===
                  "Few items from the order are not available"
                }
                onChange={handleReasonChange}
              />
              <label htmlFor="reason1">
                Few items from the order are not available
              </label>
            </div>
            <div>
              <input
                type="radio"
                id="reason2"
                name="cancelReason"
                value="Restaurant is filled up completely"
                checked={
                  selectedReason === "Restaurant is filled up completely"
                }
                onChange={handleReasonChange}
              />
              <label htmlFor="reason2">
                Restaurant is filled up completely
              </label>
            </div>
            <div>
              <input
                type="radio"
                id="reason3"
                name="cancelReason"
                value="Operational issues"
                checked={selectedReason === "Operational issues"}
                onChange={handleReasonChange}
              />
              <label htmlFor="reason3">Operational issues</label>
            </div>
            <div>
              <input
                type="radio"
                id="Other"
                name="cancelReason"
                value="Other"
                checked={selectedReason === "Other"}
                onChange={handleReasonChange}
              />
              <label htmlFor="Other">Other</label>
            </div>
            {textAreaShow && (
              <div className={`input-group ${error ? "error" : ""}`}>
                <input
                  type="text"
                  className="ReasonInput"
                  value={customeReasons}
                  onChange={handleChangeTextReason}
                />
                {error && <p className="error-message">{error}</p>}
              </div>
            )}
          </div>
          <div className="Action-button">
             <button 
              className="reject" 
              onClick={handleReject} 
              disabled={isLoading}
            >
              {isLoading ? (
                <div className="loading-spinner">
                  <div className="spinner"></div>
                </div>
              ) : (
                "Reject"
              )}
            </button>
            <button className="accept">Call Customer</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RejectModal;


